export const SMART_CARDS_COLLECTION_ID = "tanstack-smart-cards";
